import React, { useState } from "react";
import "../../styles/intake.css";

const machineOptions = [
    // Skin Rejuvenation
    "Thermage",
    "Exilis Ultra",
    "Venus Legacy",
    "EndyMed",
    "Morpheus8",
    "Sylfirm X",
    "Potenza",
    "Ultherapy",
    "Ultraformer III",
    "Doublo Gold",
    "Lumecca",
    "Alma Harmony XL Pro",
    "Icon IPL",
    "Omnilux",
    "Celluma",
    "LightStim",
    "HydraFacial",
    "Geneo",
    "Dermalinfusion",
    "OxyGeneo",
    "Intraceuticals",
    "Carbossi",
    "CO2Lift",
  
    // Pigmentation / Resurfacing / Acne
    "PicoSure",
    "PicoWay",
    "Enlighten",
    "Pastelle",
    "Discovery Pico",
    "Fraxel Dual",
    "Clear + Brilliant",
    "ResurFX",
    "eCO2",
    "SmartXide",
    "CO2RE",
    "Ultrapulse",
    "Fotona SP Dynamis",
    "Sciton ProFractional",
    "Spectra Laser",
  
    // Hair Removal
    "Soprano Ice",
    "Soprano Titanium",
    "Lightsheer",
    "Venus Velocity",
    "Candela GentleLase Pro",
    "Candela GentleYAG",
    "Cynosure Elite+",
    "Cutera Xeo",
    "Lumenis M22",
  
    // Body Contouring / Fat Reduction
    "CoolSculpting",
    "Clatuu Alpha",
    "Cristal",
    "SculpSure",
    "Strawberry Laser",
    "iLipo",
    "EMSculpt NEO",
    "TruSculpt Flex",
    "Tesla Former",
    "VelaShape III",
    "Cavi-Lipo",
    "UltraShape",
    "Liponix",
  
    // Cellulite / Lymphatic / Stretch Marks
    "LPG Endermologie",
    "Venus Freeze",
    "Secret RF",
    "Morpheus8 Body",
  
    // Vaginal Rejuvenation
    "Femilift",
    "MonaLisa Touch",
    "Juliet Laser",
    "CO2RE Intima",
    "ThermiVa",
    "Viveve",
  
    // Wellness
    "Cryo T-Shock",
    "CryoSkin",
    "Plasma Pen",
    "Fibroblast Pen",
  
    // Skin Imaging
    "VISIA",
    "Observ 520x"
  ];
  

export default function MachineSelector({ selected, setSelected }) {
  const [open, setOpen] = useState(false);

  const toggleMachine = (machine) => {
    if (selected.includes(machine)) {
      setSelected(selected.filter((m) => m !== machine));
    } else {
      setSelected([...selected, machine]);
    }
  };

  return (
    <div className="dropdown-wrapper">
      <div className="dropdown-header" onClick={() => setOpen(!open)}>
        {selected.length > 0 ? selected.join(", ") : "Select machines..."}
        <span className="arrow">{open ? "▲" : "▼"}</span>
      </div>

      {open && (
        <div className="dropdown-menu">
          {machineOptions.map((machine) => (
            <label key={machine} className="dropdown-item">
              <input
                type="checkbox"
                checked={selected.includes(machine)}
                onChange={() => toggleMachine(machine)}
              />
              {machine}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
